import { useQuery } from '@tanstack/react-query';
import { request } from './client.ts';
import { qk } from './keys.ts';
import type { Me } from '@seencast/shared';

export function getMe(): Promise<Me> {
  return request<Me>('/me');
}

export function useMe() {
  return useQuery({
    queryKey: qk.me,
    queryFn: getMe,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
